import { useEffect, useState } from 'react'

import { Card, Row, Input, Button } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useAuth, useLoading, useModal } from 'hooks'
import {
  EfetivoLogicoServices,
  ResGetAllContracts
} from 'services/Supplier/LogicalEffective'
import { COLORS, FORMAT, SPACING } from 'utils'

import { changeTabProps } from '../LogicalEffectiveRegister'
import { Collapse } from './components'
import LegendasEfetivoLogico from './components/LegendasEfetivo'

interface ISearchRegisterEffectives {
  handleChangeTab: (props: changeTabProps) => void
  activeContract: string
  reset?: boolean
  setReset?: () => void
}

const SearchRegisterEffectives: React.FC<ISearchRegisterEffectives> = ({
  handleChangeTab,
  activeContract,
  reset,
  setReset
}) => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const [searchWord, setSearchWord] = useState('')
  const [listContracts, setListContracts] = useState<ResGetAllContracts[]>([])
  const { user } = useAuth()

  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchWord(event.target.value)
  }

  const getAllContracts = async () => {
    setListContracts([])
    setLoading('loading')

    const requestObj = {
      idUsuario: user.IdUsuario,
      pesquisaGeral: searchWord
    }

    try {
      const response = await EfetivoLogicoServices().getPesquisaContratos(
        requestObj
      )

      if (response.status !== 200) {
        throw new Error('Não foi possivel obter a lista de contratos')
      }

      const filteredResponse = response.data.filter((item) => item !== null)
      if (filteredResponse.length > 0) setListContracts(response.data)
      setLoading('idle')
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          error.mensagem ||
          error.message ||
          'Não foi possivel obter a lista de contratos',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  useEffect(() => {
    if (reset) {
      getAllContracts()
      setReset()
    }
  }, [reset])

  useEffect(() => {
    if (searchWord === '') getAllContracts()
  }, [searchWord])

  return (
    <>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Row justifyContent="space-between">
          <div style={{ display: 'flex', gap: '10px' }}>
            <LegendasEfetivoLogico status='Bloqueado' />
            <LegendasEfetivoLogico status='Liberado' />
            <LegendasEfetivoLogico status='Pendente' />
            <LegendasEfetivoLogico status='Demitido' />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Input
              label="Pesquisa Geral"
              placeholder="Pesquisar"
              value={searchWord}
              onChange={handleChangeSearch}
              onClickIcon={() => getAllContracts()}
              inputIcon={<MagnifyingGlassIcon />}
              marginRight={SPACING.spacing5}
              marginBottom={SPACING.spacing10}
              width={SPACING.spacing300}
            />
            <Button
              text="Limpar"
              variantButton="text"
              onClick={() => setSearchWord('')}
            />
          </div>
        </Row>
        <Collapse
          activeContract={activeContract}
          collapses={listContracts}
          handleChangeTab={handleChangeTab}
          pesquisaGeral={searchWord}
        />
      </Card>
    </>
  )
}

export default SearchRegisterEffectives
